import React from 'react';
import {query} from 'api';
import PropTypes from 'prop-types';
import Academie from './academie';
import {HrLine} from 'ui';
import {MainTitleDark, Container} from './styles';

const Academies = ({data}) => (
  <Container>
    <MainTitleDark>Qu’est-ce que les Ateliers de l’Académie ?</MainTitleDark>
    <HrLine />
    {data.map(academieData => (
      <Academie
        key={academieData.id}
        academie_miniature={academieData.acf.academie_miniature}
        academie_video={academieData.acf.academie_video}
        title={academieData.title.rendered}
        academie_sous_titre={academieData.acf.academie_sous_titre}
      />
    ))}
  </Container>
);

Academies.propTypes = {
  data: PropTypes.array,
};

export default Academies |> query('getAcademies');
